module.exports = __webpack_public_path__ + "static/media/noul_succes.8bb7ca1f.png";